import { useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Frases graciosas de carga por defecto
const DEFAULT_LOADING_PHRASES = [
  "Cargando... no te desesperes, wey",
  "Espérate tantito, no seas impaciente",
  "Ya casi... o eso creo",
  "Buscando videos chidos...",
  "El internet está lento, no es mi culpa",
  "Cargando mamadas...",
  "Un momento, estoy pensando...",
  "No le muevas, ya mero",
  "Preparando el desmadre...",
  "Aguas, que ya viene lo bueno",
  "Calmantes montes...",
  "Échale ganas al WiFi",
  "Invocando al Darkar...",
  "Conectando neuronas...",
  "¿Sigues ahí? Yo también",
];

export const FunnyLoader = ({ className = "" }) => {
  const [phrases, setPhrases] = useState(DEFAULT_LOADING_PHRASES);
  const [phrase, setPhrase] = useState("");
  const [dots, setDots] = useState("");

  useEffect(() => {
    // Fetch custom phrases from API
    const fetchPhrases = async () => {
      try {
        const res = await axios.get(`${API}/phrases?phrase_type=loading&active_only=true`);
        if (res.data && res.data.length > 0) {
          setPhrases(res.data.map(p => p.text));
        }
      } catch (error) {
        // Use default phrases if API fails
      }
    };
    fetchPhrases();
  }, []);

  useEffect(() => {
    // Set random phrase on mount or when phrases change
    setPhrase(phrases[Math.floor(Math.random() * phrases.length)]);

    // Animate dots
    const dotsInterval = setInterval(() => {
      setDots(prev => prev.length >= 3 ? "" : prev + ".");
    }, 400);

    // Change phrase every 3 seconds
    const phraseInterval = setInterval(() => {
      setPhrase(phrases[Math.floor(Math.random() * phrases.length)]);
    }, 3000);

    return () => {
      clearInterval(dotsInterval);
      clearInterval(phraseInterval);
    };
  }, [phrases]);

  return (
    <div className={`flex flex-col items-center justify-center gap-6 ${className}`}>
      {/* Spinner divertido */}
      <div className="relative">
        <div className="w-16 h-16 rounded-full border-4 border-gray-200 border-t-[#E91E8C] border-r-[#FFE500] loading-spin" />
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="text-2xl">🎬</span>
        </div>
      </div>
      
      {/* Frase graciosa */}
      <p className="text-gray-600 text-lg font-medium text-center blink-fun">
        {phrase}<span className="text-[#E91E8C]">{dots}</span>
      </p>
    </div>
  );
};

// Hook para obtener frases de estado vacío
export const useEmptyPhrases = () => {
  const [phrases, setPhrases] = useState([
    "Aquí no hay nada... como tu refrigerador a fin de quincena 🥲",
    "Vacío como las promesas de año nuevo",
    "Nada que ver aquí... literalmente",
    "¿Buscas contenido? Pues no hay, sorry not sorry",
    "Esto está más solo que el último churro de la bolsa",
  ]);

  useEffect(() => {
    const fetchPhrases = async () => {
      try {
        const res = await axios.get(`${API}/phrases?phrase_type=empty&active_only=true`);
        if (res.data && res.data.length > 0) {
          setPhrases(res.data.map(p => p.text));
        }
      } catch (error) {
        // Use default phrases if API fails
      }
    };
    fetchPhrases();
  }, []);

  const getRandomPhrase = () => phrases[Math.floor(Math.random() * phrases.length)];

  return { phrases, getRandomPhrase };
};

// Skeleton con estilo divertido
export const FunnySkeleton = ({ className = "" }) => {
  return (
    <div className={`animate-pulse ${className}`}>
      <div className="bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 rounded-xl h-full w-full" 
           style={{ backgroundSize: '200% 100%', animation: 'shimmer 1.5s infinite' }} />
    </div>
  );
};
